import dayjs from 'dayjs';

export interface SuiviFinancier {
    adresseSite: string;
    numeroIntervention: string;
    objet: string;
    type: string;
    dateRealisationIntervention: Date;
    mainOeuvre: string;
    pieces: string;
    montantTtc: string;

    devise: string;
    pdfExist: boolean;
    chantierId: number;
}
export class SuiviFinancier {
    adresseSite: string;
    reference: string;
    objet: string;
    type: string;
    dateRealisation: string;
    facturee: boolean;
    mainOeuvre: string;
    pieces: string;
    total: string;
    pdfExist: boolean;

    constructor(obj: SuiviFinancier) {
        this.adresseSite = obj.adresseSite;
        this.reference = obj.numeroIntervention;
        this.objet = obj.objet;
        this.type = obj.type;
        this.dateRealisation = obj.dateRealisationIntervention != null ? dayjs(obj?.dateRealisationIntervention).format('DD/MM/YYYY') : '';
        this.facturee = obj.facturee;
        this.mainOeuvre = `${obj?.mainOeuvre ? montantWithSpace(obj?.mainOeuvre) : ''} ${ (obj?.mainOeuvre && obj?.devise) ? obj?.devise : ''}`;
        this.pieces = `${obj?.pieces ? montantWithSpace(obj?.pieces) : ''} ${ (obj?.pieces && obj?.devise) ? obj?.devise : ''}`;
        this.total = `${obj?.montantTtc ? montantWithSpace(obj?.montantTtc) : ''} ${ (obj?.montantTtc && obj?.devise) ? obj?.devise : ''}`;
        this.pdfExist = obj.facturee;
    }
}

export class SuiviFinancierFull {
    adresseSite: string;
    reference: string;
    objet: string;
    type: string;
    dateRealisation: string;
    facturee: boolean;
    mainOeuvre: string;
    pieces: string;
    total: string;
    pdfExist: boolean;
    chantierId: number;

    constructor(obj: SuiviFinancier) {
        this.adresseSite = obj.adresseSite;
        this.reference = obj.numeroIntervention;
        this.objet = obj.objet;
        this.type = obj.type;
        this.dateRealisation = obj.dateRealisationIntervention != null ? dayjs(obj?.dateRealisationIntervention).format('DD/MM/YYYY') : '';
        this.facturee = obj.facturee;
        this.mainOeuvre = `${obj?.mainOeuvre ? montantWithSpace(obj?.mainOeuvre) : ''} ${ (obj?.mainOeuvre && obj?.devise) ? obj?.devise : ''}`;
        this.pieces = `${obj?.pieces ? montantWithSpace(obj?.pieces) : ''} ${ (obj?.pieces && obj?.devise) ? obj?.devise : ''}`;
        this.total = `${obj?.montantTtc ? montantWithSpace(obj?.montantTtc) : ''} ${ (obj?.montantTtc && obj?.devise) ? obj?.devise : ''}`;
        this.pdfExist = obj.facturee;
        this.chantierId = obj.chantierId;
    }
}

const montantWithSpace = (montant: string) => {
    //Ajoute un espace tout les 3 chiffres pour éviter un effet tout collé
    return (Math.round(parseFloat(montant) * 100) / 100).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};
